import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { FileItem } from "./styled";
import { toast } from "react-toastify";

export const ProfessionalDocsModal = ({ open, onClose, professional }) => {
  const handleCurriculumClick = (url) => {
    window.open(url, "_blank");
  };

  const handleCourseClick = (course) => {
    if (course.certificate) {
      window.open(course.certificate, "_blank");
    } else {
      toast.warn("Não foi feito o upload desse certificado");
    }
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "700px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">
        {"Documentos do(a) profissional"}
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            padding: "10px 20px",
            minWidth: "300px",
            width: "100%",
            gap: "1.5rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <h2>{"Currículo:"}</h2>
            {professional && professional.curriculum ? (
              <FileItem
                onClick={() => handleCurriculumClick(professional.curriculum)}
              >
                <span
                  style={{ color: "#104467", fontWeight: "bold" }}
                >{`Currículo - ${professional.name}${professional.cpf ? " (" + professional.cpf + ")" : ""}`}</span>
              </FileItem>
            ) : (
              <span>{"Esse profissional não possui currículo cadastrado"}</span>
            )}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <h2>{"Certificados:"}</h2>
            {professional && professional.courses.length > 0 ? (
              professional.courses.map((course) => (
                <FileItem
                  key={`course${professional.courses.indexOf(course)}`}
                  onClick={() => handleCourseClick(course)}
                >
                  <span
                    style={{ color: "#104467", fontWeight: "bold" }}
                  >{`${course.course} | ${course.deliveryMode}`}</span>
                  <span>{`${course.origin} (${course.year})`}</span>
                </FileItem>
              ))
            ) : (
              <span>
                {"Esse profissional não possui certificados cadastrados"}
              </span>
            )}
          </div>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
